import { ID } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type CreateStripeSubscriptionManagementUrlOptions<TFunctions> = {
  stripeCustomerId: ID;
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
};

export const createStripeSubscriptionManagementUrl = async <TFunctions>({
  stripeCustomerId,
  functions,
  httpsCallable,
}: CreateStripeSubscriptionManagementUrlOptions<TFunctions>): Promise<string> => {
  const callable = httpsCallable<{ stripeCustomerId: ID }, string>(
    functions,
    'stripe-onCreateManagementUrl',
  );
  const { data } = await callable({ stripeCustomerId });
  return data;
};
